// extracted by mini-css-extract-plugin
module.exports = {"box":"box___16XUm","box_title":"box_title___WoQwt","keys_box":"keys_box___2KgEG","key_item":"key_item___2McEA"};